import { http, createConfig } from 'wagmi'
import { base, mainnet, optimism } from 'wagmi/chains'
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'


const projectId = 'ca91560d29405fd56cc374dd5e2c981e'

export const config = createConfig({
  chains: [mainnet, base],
  connectors: [
    injected(),walletConnect({ projectId }),metaMask(),safe()
  ],
  transports: {
    [mainnet.id]: http(),
    [base.id]: http(),
  },
})